import { BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";

import Homepage from "./pages/Homepage";
import AdminLogin from "./admin/pages/AdminLogin";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import ApplyHistory from "./pages/ApplyHistory";
import InstitutionDashboard from "./pages/InstitutionDashboard";
import JobDetails from "./pages/JobDetails";
import CandidateDashboard from "./pages/CandidateDashboard";
import CandidateProfileView from "./pages/CandidateProfileView";
import JobsMore from './pages/JobsMore';
import FindJobs from "./pages/FindJobs";
import ForEmployers from "./pages/ForEmployers";
import HowItWorks from "./pages/HowItWorks";
import AdminRoutes from "./admin/AdminRoutes";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

function App() {
    return (
        <Router>

            <Routes>

                {/* Home */}
                <Route
                    path="/"
                    element={<Homepage />}
                />

                {/* Authentication */}
                <Route
                    path="/login"
                    element={<Login />}
                />

                <Route
                    path="/register"
                    element={<Register />}
                />

                {/* Candidate */}
                <Route
                    path="/profile"
                    element={<Profile />}
                />

                <Route
                    path="/applications"
                    element={<ApplyHistory />}
                />

                <Route
                    path="/candidate-dashboard"
                    element={<CandidateDashboard />}
                />

                <Route
                    path="/candidate/:id"
                    element={<CandidateProfileView />}
                />

                {/* Institution */}
                <Route
                    path="/institution"
                    element={<InstitutionDashboard />}
                />

                <Route
                path="/institution-dashboard"
                element={<Navigate to="/institution" replace />}
                />


                <Route
                    path="/job/:id"
                    element={<JobDetails />}
                />

                {/* Admin */}
                <Route
                    path="/admin/*"
                    element={<AdminRoutes />}
                />
                <Route
                    path="/admin/login"
                    element={<AdminLogin />}
                />
                <Route path="/jobs" element={<JobsMore />} />
                <Route
            path="/find-jobs"
            element={<FindJobs />}
            />
            {/* For Employers */}
            <Route
            path="/for-employers"
            element={<ForEmployers />}
            />
            {/* How It Works */}
<Route
  path="/how-it-works"
  element={<HowItWorks />}
/>
        <Route
  path="/about-us"
  element={<AboutUs />}
/>
            <Route
  path="/contact-us"
  element={<ContactUs />}
/>
            <Route
  path="/privacy-policy"
  element={<PrivacyPolicy />}
/>
            <Route
  path="/terms-and-conditions"
  element={<TermsAndConditions />}
/>
            </Routes>

        </Router>
    );
}

export default App;